import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CommonMuiTable, { Table } from "../../Component/Table/Table";
import { delete_icon, View_icon } from "../../assets/img";

import { URLS } from "../../Services/Constant";
import { get, post } from "../../Services/ApiHandler";
import useStoreKv from "../redux/store/useStorekv";
import CustomScroll from "../../Component/CustomScroll";
import useStore from "../redux/store/useStore";
import RawWebSocket from "../../Websocker/RawWebSocket";
import { MaskIcon } from "../../Component/MaskIcon";

const HelpSupport = () => {
  const navigate = useNavigate();

  const { kv, set } = useStoreKv();
  const helpSupport = kv.helpsupport || [];
  const { user } = useStore();
  const [page, setPage] = useState(1);
  const [idd, setIdd] = useState(null);
  const [pagination, setPagination] = useState("");

  const [popup, setPopup] = useState(false);

  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [owners, setOwners] = useState(helpSupport);

  const getList = async () => {
    if (!kv.helpsupport || kv.helpsupport.length === 0) {
      setLoading(true);
    }
    const res = await get(URLS.CHAT);
    if (res.status === "success") {
      setOwners(res?.data);
      setLoading(false);
      set("helpsupport", res?.data);
    } else {
      setOwners([]);
      set("helpsupport", []);
      setLoading(false);
    }
  };

  useEffect(() => {
    getList();
    const unsubscribe = RawWebSocket.listen("chat_message", (e) => {
      setOwners((prev) => {
        let modified = prev.map((item) =>
          item?.client_id === e?.data?.client_id
            ? {
                ...item,
                unseen_count: item.unseen_count + 1,
                message: e?.data?.message,
              }
            : item,
        );
        set("helpsupport", modified);
        return modified;
      });
    });
    return () => {
      unsubscribe();
    };
  }, []);

  const handleDelete = async (id) => {
    if (!idd) return;
    setIsLoading(true);
    const res = await post(`${URLS.CHAT}/delete`, { client_id: idd });
    if (res.status === "success") {
      setPopup(false);
      getList();
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{row.index + 1}</p>;
        },
      },
      {
        Header: () => (
          <div style={{ textAlign: "center" }}>
            Client <br /> ID
          </div>
        ),
        accessor: "client_id",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Mobile No",
        accessor: "mobile",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Description",
        accessor: "message",
        Cell: ({ value, row }) => {
          return (
            <p
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "130px",
              }}
            >
              {value}
            </p>
          );
        },
      },
      {
        Header: "Action",
        accessor: "unseen_count",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc gap-3">
                <button
                  onClick={() => {
                    navigate("/help-chat", {
                      state: {
                        chatId: row.original?.client_id,
                        client_name: row.original?.client_name,
                        mobile: row.original?.mobile,
                      },
                    });
                  }}
                  style={{ position: "relative" }}
                  className="cust-btn"
                >
                  {value > 0 && (
                    <p style={{ fontSize: 12 }} className="f2 noti-text">
                      {value}
                    </p>
                  )}
                  <MaskIcon
                    src={View_icon}
                    width={18}
                    height={18}
                    alt=""
                    className="view-btn"
                  />
                </button>

                <button
                  onClick={() => {
                    setPopup(true);
                    setIdd(row.original?.client_id);
                  }}
                  className="cust-btn"
                >
                  <img src={delete_icon} alt="" className="delete-icon" />
                </button>
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [],
  );

  return (
    <div className="dashRightView ">
      <CustomScroll>
        <div className="container_overalls">
          {/* ── Top bar: New Chat button ── */}
          <div
            className="d-flex ac-je"
            style={{ marginBottom: 12 }}
          >
            <button
              className="add-button f3"
              style={{width:'35%' , fontSize:'13px'}}
              onClick={() =>
                navigate("/help-chat", {
                  state: { isNewChat: true },
                })
              }
            >
            New Chat
            </button>
          </div>

          <Table
            columns={columns}
            setPageno={setPage}
            pagecount={pagination}
            data={owners}
            show={false}
          />
        </div>
      </CustomScroll>

      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
              Are you sure you want to Delete?
            </p>
            <div
              style={{ paddingTop: 20 }}
              className="d-flex ac-jb px-2 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
            >
              <button onClick={() => setPopup(false)} className="no-btn w-40">
                No
              </button>
              <button
                onClick={handleDelete}
                className="yes-btn f2 w-40 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
              >
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white", padding: 8 }}
                    ></span>
                  </>
                ) : (
                  <span style={{ top: -1.5, position: "relative" }}>Yes</span>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HelpSupport;
